import React from 'react'
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined'
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined'

import {
  chatbotAgentsList,
  templatesList,
  apiKeysList,
  howToVideos,
  userGuide,
  support,
  userToolsList,
  skillsList,
  playground,
  teams,
  organizationSettings,
  memory,
} from '@constants/routing'
import { useAuth } from 'torqcloud-ui'
import useOrganizationSettingsAccess from '@/hooks/useOrganizationSettingsAccess'

import Sidebar, { SidebarSection } from '../Layout/Sidebar/Sidebar'
import { appConfig } from '@/config'
import VideoPlayer from '@/icons/VideoPlayer'
import QuestionMarkCircled from '@/icons/QuestionMarkCircled'
import ChatMessage from '@/icons/ChatMessage'
import Chat from '@/icons/Chat'
import Globe from '@/icons/Globe'
import Template2 from '@/icons/Template2'
import Team from '@/icons/Team'
import KeyHorizontal from '@/icons/KeyHorizontal'

interface DashboardSidebarProps {
  onMobileClose: (isOpen?: boolean) => void
  openMobile: boolean
}

export default function DashboardSidebarTorqCloud({ onMobileClose, openMobile }: DashboardSidebarProps) {
  const { permissions } = useAuth()
  const { canAccessOrganizationSettings } = useOrganizationSettingsAccess()
  const iconStyle: React.CSSProperties = { width: '1.3rem', height: '1.3rem', margin: 0 }

  const sections: SidebarSection[] = [
    {
      title: 'Teammate Builder',
      items: [
        {
          title: 'Playground',
          path: playground(),
          icon: <Globe style={iconStyle} />,
          childItems: [],
        },
        {
          title: 'Teammates',
          path: chatbotAgentsList(),
          icon: <Chat style={iconStyle} />,
          childItems: [],
        },
        {
          title: 'Templates', // Agent Templates
          path: templatesList(),
          icon: <Template2 style={iconStyle} />,
          childItems: [],
        },
        ...(permissions?.canAccessMemories
          ? [
              {
                title: 'Memory',
                path: memory(),
                icon: <StorageOutlinedIcon style={iconStyle} />,
                childItems: [],
              },
            ]
          : []),
        ...(permissions?.canAccessTeamsV2
          ? [
              {
                title: 'Teams',
                path: teams(),
                icon: <Team style={iconStyle} />,
                childItems: [],
              },
            ]
          : []),
        ...(permissions?.canAccessUserTools
          ? [
              {
                title: 'Tools',
                path: userToolsList(),
                icon: <HandymanOutlinedIcon style={iconStyle} />,
                childItems: [],
              },
            ]
          : []),
        {
          title: 'Skills',
          path: skillsList(),
          icon: <AutoFixHighOutlinedIcon style={iconStyle} />,
          childItems: [],
        },
        {
          title: 'Keys & Secrets',
          path: apiKeysList(),
          icon: <KeyHorizontal style={iconStyle} />,
          childItems: [],
        },
      ],
    },
    ...(canAccessOrganizationSettings
      ? [
          {
            title: 'Settings',
            items: [
              {
                title: 'Organization Settings',
                path: organizationSettings(),
                icon: <BusinessOutlinedIcon style={iconStyle} />,
                childItems: [],
              },
            ],
          },
        ]
      : []),
    {
      title: 'Help & Support',
      items: [
        ...(appConfig.helpArticles.howToVideos
          ? [
              {
                title: 'How To Videos',
                path: howToVideos(),
                icon: <VideoPlayer style={iconStyle} />,
                childItems: [],
              },
            ]
          : []),
        ...(appConfig.helpBaseUrl
          ? [
              {
                title: 'User Guide',
                path: userGuide(),
                icon: <QuestionMarkCircled style={iconStyle} />,
                childItems: [],
              },
            ]
          : []),
        {
          title: 'Support',
          path: support(),
          icon: <ChatMessage style={iconStyle} />,
          childItems: [],
        },
      ],
    },
  ]

  return <Sidebar sections={sections} onMobileClose={onMobileClose} openMobile={openMobile} />
}
